import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  Breadcrumb,
  BreadcrumbLinkMouseEvent,
  BreadcrumbLinkKeyDownEvent,
} from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import "./breadcrumb.scss";


interface Props {
  name?: string;
  data?: any;
  onItemSelect?: any;
}

const Breadcrumbs: React.FC<Props> = ({ data, onItemSelect }) => {
  return (
    <div className="breadcrumb">
    <Breadcrumb
      data={data}
      onItemSelect={onItemSelect}
      valueField="text"
    />
    </div>
  );
};

export default Breadcrumbs;
